<template>
    <div class="search">
        <div class="search-input">
            <input type="text" @input="search" v-model="searchText" ref="searchInput" autofocus @focus="opened=true" />
            <i class="icon icon-search"></i>
        </div>

        <div class="option-dropdown" v-if="(amps.length > 0 || vmps.length > 0) && opened">
            <div class="option-subtitle" v-if="amps.length > 0">MEDICAMENTOS COMERCIALES</div>
            <div class="item" v-for="option in amps" :key="option.id" @click="selectAMP(option)">
                <div>
                    {{ option.labName }}<br />
                    <strong>{{ option.name }}</strong>
                    <div class="text-secondary">
                        <span v-for="(droug, i) in option.substances" :key="i" style="margin-right:6px">{{ droug.name }}</span>
                    </div>
                </div>
            </div>

            <div class="option-subtitle" v-if="vmps.length > 0">MEDICAMENTOS GENERICOS</div>
            <div class="item" v-for="option in vmps" :key="option.VMP_Id" @click="selectVMP(option)">
                <div>
                    <strong>{{ option.name }}</strong>
                    <div class="text-secondary">
                        <span v-for="(droug, i) in option.substances" :key="i">{{ droug.name }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import gql from "graphql-tag"

export default {
	name: "ProductSearch",
	data() {
		return {
			searchText: "",
			loading: true,
            opened: false,
			product: null,
            amps: [],
            vmps: []
		}
	},

	mounted() {
		this.$nextTick(() => this.$refs.searchInput.focus())
	},

	methods: {

        selectAMP(amp) {
            this.$emit("selected", amp)
            this.opened = false
			this.searchText = amp.name
        },
        selectVMP(vmp) {
            this.$emit("selected", vmp)
            this.opened = false
        },
		
		search() {
			if (this.searchText != "") {
				this.$apollo
					.query({
						query: gql`
							query($take: Int, $skip: Int, $search: String) {
								products(take: $take, skip: $skip, search: $search) {
									data {
										id
										type
										name
										labName
										substances {
											name
											dosif
											unit
										}
										dosificationUnit
										dosificationType
									}
									pageInfo {
										totalItems
									}
								}
							}
						`,
						variables: {
							take: 10,
							skip: 0,
							search: this.searchText
						},
						fetchPolicy: "no-cache"
					})
					.then(data => {
						console.log(data)
						this.amps = data.data.products.data.filter(item => item.type == "AMP")
						this.vmps = data.data.products.data.filter(item => item.type == "VMP")

						this.loading = false
					})

			}
		}
	}
}
</script>

<style scoped>
.search {
	position: relative;
}

.search-input {
	cursor: pointer;
	border-radius: 0.3em;
	color: #000;
	border: 1px solid #cecece;
	padding: 0px 10px;
	width: 100%;
	display: flex;
	align-items: center;
}
.search-input input:focus {
	border: none !important;
	outline: none !important;
}
.search-input input {
	height: 37px;
	color: #000;
	border: none;
	width: 100%;
}
.option-subtitle {
	padding: 8px;
	font-size: 11px;
	color: #fff;
	background-color: #00b3b6;
}
.option-dropdown {
	display: block;
	box-sizing: border-box;
	position: absolute;
	top: calc(100% - 1px);
	left: 0;
	z-index: 1000;
	padding: 5px 0;
	margin: 0;
	width: 100%;
	max-height: 350px;
	min-width: 160px;
	overflow-y: auto;
	-webkit-box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.15);
	box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.15);
	border: 1px solid rgba(60, 60, 60, 0.26);
	border-top-style: none;
	border-radius: 0 0 4px 4px;

	background-color: #fff;
}
.option-dropdown .item {
	border-bottom: 1px solid #d3d3d3;
	padding: 10px;
	line-height: 14px;
}
.option-dropdown .item strong {
	font-size: 13px;
}
.option-dropdown .item span {
	font-size: 13px;
}
.option-dropdown .item:hover {
	background-color: #f3f3f3;
	cursor: pointer;
}

.formulate-input[data-type="keyValue"] /deep/ input::-webkit-outer-spin-button,
.formulate-input[data-type="keyValue"] /deep/ input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

.formulate-input[data-type="keyValue"] /deep/ input[type="number"] {
	-moz-appearance: textfield;
	padding: 0.75em 0.2em;
	text-align: center;
}
</style>
